import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import HomeFeaturedCarousel from '../components/HomeFeaturedCarousel';
import HomePlaylistsCarousel from '../components/HomePlaylistsCarousel';
import SelectedPlaylistCarousel from '../components/SelectedPlaylistCarousel';
import { fetchUserPlaylist, fetchPlaylist } from '../actions/playlistActions';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import Cookies from 'js-cookie';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import { setArtInterval, getArtInterval, setQualityFlag, setMuteFlag, getQualityFlag, getMuteFlag, setFirstTime, getFirstTime, getIsHomeFirstScreen, setFirst, getFirst, sendPlaylists, sendArtworks, sendCanvasDetails, sendMuteAndQualityFlagStatus } from './utils'

export class Home extends React.Component {
  constructor(props) {
    super(props);
    this.featured  = store.get('featured');
    this.state = {
      id: '',
      firstTimeLoad: false,
      loaded: false,
      userPlaylist: [] || props.userPlaylist,
      playlist: {} || props.playlist,
      currentPlaylist: {} || props.currentPlaylist,
      quality: "high",
      playlistFirstTime: null,
      name:"FEATURED",
    }

    this.k = 0;
    this.firstTime = '';
  }

  componentWillMount() {
    if (bdAuth.getToken()) {
      bdAuth.checkToken();
    }

    if (getIsHomeFirstScreen()) {
      if (getFirstTime()) {
        setFirstTime(false)
      } else {
        this.setState({
          loaded: true
        })
      }
    } else {
      this.setState({
        loaded: true
      })
    }

    if (getFirst() < 2) {
      this.firstTime = true;
      if (getFirst() != 1) {
        setFirst(2)
      }
    } else {
      this.firstTime = false;
    }

    const user = store.get('auth__user') || '';
    const id = user.id ? user.id : user || '';
    const { dispatch, playlist, userPlaylist} = this.props;
    if (playlist.length == 0) {
      fetchPlaylist(dispatch);
    }
    if (userPlaylist.length == 0) {
      // fetchDiscoverPlaylist(dispatch, id);
      fetchUserPlaylist(dispatch, id);
    }

    const deviceName = store.get('device-name');
    const deviceId = store.get('bd-android-app__device-id');
    sendCanvasDetails(deviceName, deviceId);
  }

  componentDidMount() {
    let userPlaylist = this.props.userPlaylist;
    let playlist = this.props.playlist;
    if (playlist != {} && userPlaylist.length > 0) {
      this.setState({
        loaded: true,
      })

      if (!this.firstTime) {
        this.setState({
          userPlaylist,
          playlist,
          firstTimeLoad: true,
        })
      }

      if (this.state.loaded) {
        var home = this.refs.home;
        home.focus();
      }
    }
    this.interval = setInterval(() => this.FetchFromMobile(), 1000);
  }

  componentWillReceiveProps(nextprops) {
    if (this.firstTime) {
      let userPlaylist = nextprops.userPlaylist;
      if (nextprops.playlist != {} && userPlaylist.length > 0) {
        this.setState({
          userPlaylist,
          playlist: nextprops.playlist,
          loaded: true,
        })

        if (getFirst() == 1) {
          setTimeout(() => {
            this.setState({
              firstTimeLoad: true,
            })
          }, 1000)
          setFirst(2)
        } else {
          this.setState({
            firstTimeLoad: true,
          })
        }
        this.firstTime = false;
        setTimeout(() => {
          var home = this.refs.home;
          home.focus();
        }, 500)
      }
    }
    else {
      this.setState({
        playlist: nextprops.currentPlaylist,
      })

    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  

  FetchFromMobile() {
    const deviceId = store.get('device-id');
    const user = store.get('auth__user');
    const id = user.id ? user.id : user;
    bdReq.post(`/users/${id}/devices/${deviceId}/play`)
      .then((data) => {
        store.set('device-name', data.body.device.name);
        const sessionLastUpdatedAt = store.get('sessionLastUpdatedAt') || '';
        if (data.body.sessionLastUpdatedAt != sessionLastUpdatedAt) {
          if (data.success) {
            if (data.body.queue == null) {
              return;
            }
            store.set('sessionLastUpdatedAt', data.body.sessionLastUpdatedAt)
            const artworkList = data.body.queue.artworks;
            const playlistName = data.body.queue.name;
            if (data.body.device.highQuality) {
              this.setState({
                quality: "4k"
              })
            } else {
              this.setState({
                quality: "high"
              })
            }
            const deviceName = store.get('device-name');
            sendArtworks(artworkList, playlistName, this.state.quality, data.body.device.mute, "true", 0, "false", "true", data.body.device.interval);
          }
        }

        if (getMuteFlag() != data.body.device.mute || getQualityFlag() != data.body.device.highQuality || getArtInterval() != data.body.device.interval) {
          if (data.body.device.highQuality) {
            this.setState({
              quality: "4k"
            })
          } else {
            this.setState({
              quality: "high"
            })
          }
          sendMuteAndQualityFlagStatus(this.state.quality, data.body.device.mute, data.body.device.interval);
        }

        setMuteFlag(data.body.device.mute);
        setQualityFlag(data.body.device.highQuality);
        setArtInterval(data.body.device.interval)
      })
      .catch(err => { });
  }

  render() {
    if((Array.isArray(this.props.currentPlaylist.artworks) && this.props.currentPlaylist.artworks.length)) {
      store.set("CurrentPlaylist", this.props.currentPlaylist)
    }

    if (this.state.loaded) {
      return (
        <div className="home">
          <div className="home__header">
            <img className="home__header__logo" src="/assets/img/logo.png" />
            <a id='home' tabIndex="11" className="home__header__btn btn--active" ref='home'>Home</a>
            <a tabIndex="12" className="home__header__btn" onClick={() => this.props.history.push('/info-page')}>Account</a>
            <div className="home__header__notice">
              <span className="" class="ion-ios-information home__header__notice__sign"></span>
              <div className="home__header__notice__txt"><b style={{ fontweight: '900', color: '#E1E6EA' }}>Tip:</b> Control your tv with the Blackdove mobile app<br />Available on the App store and Google play store</div>
            </div>
          </div>
          {
            this.state.firstTimeLoad ?
              <div style={{ display: "inline" }}>
                <div className="home__body" >
                  <h4 style={{ height: '15%', marginLeft: '2.9em', marginBottom: '0px', display: 'inline-block' }} className="h--no-spacing">{this.featured ? store.get('CurrentPlaylist').name:this.state.playlist.name}</h4>
                  <HomeFeaturedCarousel history={this.props.history} playlist={this.featured ? this.state.playlistFirstTime ? this.props.currentPlaylist:store.get('CurrentPlaylist'):this.state.playlist} focus="true" />
                </div>
                <div className="home__footer text-center">
                  <div className="full-size">
                    <SelectedPlaylistCarousel history={this.props.history} playlist={this.state.userPlaylist[0].content} dispatch = {this.props.dispatch} />
                  </div>
                </div>
              </div>
              :
              <div className="loader-container"><span className="spinner spinner--small loader-container__loader" ></span></div>
          }
        </div>
      );
    }
    else {
      return (
        <section className="start-page">
          <div className="start-page__container">
            <img className="start-page__container__image" src="https://assets.blackdove.com/images/horizontal_alternate.svg" /><br />
            <span className="spinner spinner--small start-page__container__loader" ></span>
          </div>
        </section>
      )
    }
  }
}

export default connect((state) => {
  const { playlist, userPlaylist, history,currentPlaylist} = state;
  return {
    playlist,
    userPlaylist,
    history,
    currentPlaylist
  }
})(Home)